export default "data:image/gif;base64,R0lGODlhEgAMAPAAAP8AAP//ACH5BAAAAAAALAAAAAASAAwAAAIWhA+Bi8pvgjwORvtUrbhj7oXiSJZWAQA7"